import React, { useState, useEffect } from 'react';

const PreviewPage = () => {
  const [expiryDate] = useState(new Date(Date.now() + 48 * 60 * 60 * 1000));

  useEffect(() => {
    // No countdown needed for this design
  }, []);

  const styles = {
    body: {
      margin: 0,
      padding: 0,
      fontFamily: "'Helvetica Neue', Arial, sans-serif",
      backgroundColor: '#1a1a1a',
      minHeight: '100vh',
    },
    emailContainer: {
      maxWidth: '600px',
      margin: '0 auto',
      backgroundColor: '#1a1a1a',
    },
    viewOnline: {
      backgroundColor: '#1a1a1a',
      textAlign: 'center',
      padding: '10px',
      fontSize: '11px',
      color: '#8a8a8a',
      textTransform: 'uppercase',
      letterSpacing: '1px',
    },
    logoSection: {
      backgroundColor: '#1a1a1a',
      textAlign: 'center',
      padding: '30px 20px 40px 20px',
    },
    logo: {
      maxWidth: '200px',
      height: 'auto',
      margin: '0 auto',
    },
    heroBanner: {
      backgroundColor: '#f5f1eb',
      padding: '60px 40px',
      textAlign: 'center',
    },
    heroTitle: {
      fontSize: '24px',
      fontWeight: '700',
      letterSpacing: '3px',
      textTransform: 'uppercase',
      margin: '0 0 8px 0',
      color: '#1a1a1a',
    },
    heroSubtitle: {
      fontSize: '32px',
      fontWeight: '700',
      letterSpacing: '2px',
      textTransform: 'uppercase',
      margin: '0 0 30px 0',
      color: '#1a1a1a',
      lineHeight: '1.2',
    },
    heroButton: {
      display: 'inline-block',
      padding: '15px 55px',
      backgroundColor: 'transparent',
      border: '2px solid #1a1a1a',
      color: '#1a1a1a',
      textDecoration: 'none',
      textTransform: 'uppercase',
      fontWeight: '600',
      fontSize: '12px',
      letterSpacing: '2px',
      borderRadius: '25px',
      cursor: 'pointer',
    },
    productSection: {
      backgroundColor: '#1a1a1a',
      padding: '70px 50px',
      display: 'flex',
      gap: '35px',
      alignItems: 'center',
    },
    productImage: {
      flex: '0 0 240px',
    },
    productImageImg: {
      width: '100%',
      height: 'auto',
      borderRadius: '4px',
    },
    productDetails: {
      flex: '1',
      color: '#ffffff',
    },
    productLabel: {
      fontSize: '11px',
      textTransform: 'uppercase',
      letterSpacing: '2px',
      color: '#8a8a8a',
      margin: '0 0 18px 0',
    },
    productTitle: {
      fontSize: '26px',
      fontWeight: '700',
      color: '#ffffff',
      margin: '0 0 18px 0',
      lineHeight: '1.3',
    },
    productDescription: {
      fontSize: '14px',
      lineHeight: '1.7',
      color: '#b8b8b8',
      margin: '0 0 30px 0',
    },
    priceDivider: {
      height: '1px',
      backgroundColor: '#333333',
      margin: '30px 0 25px 0',
    },
    saveBadge: {
      fontSize: '30px',
      fontWeight: '700',
      color: '#ffffff',
      margin: '0 0 12px 0',
    },
    priceContainer: {
      margin: '0 0 25px 0',
    },
    originalPrice: {
      fontSize: '15px',
      color: '#8a8a8a',
      textDecoration: 'line-through',
      marginRight: '15px',
    },
    salePrice: {
      fontSize: '30px',
      fontWeight: '700',
      color: '#ffffff',
    },
    priceDividerBottom: {
      height: '1px',
      backgroundColor: '#333333',
      margin: '25px 0 25px 0',
    },
    expiryNotice: {
      backgroundColor: '#2e2e2e',
      borderLeft: '3px solid #666666',
      padding: '15px 18px',
      margin: '25px 0',
      textAlign: 'left',
      color: '#cccccc',
      fontSize: '12px',
      lineHeight: '1.6',
    },
    downloadButton: {
      display: 'inline-block',
      padding: '15px 50px',
      backgroundColor: '#ffffff',
      color: '#1a1a1a',
      textDecoration: 'none',
      textTransform: 'uppercase',
      fontWeight: '600',
      fontSize: '12px',
      letterSpacing: '2px',
      borderRadius: '25px',
      marginTop: '5px',
      cursor: 'pointer',
      border: 'none',
    },
    ctaSection: {
      backgroundColor: '#f5f1eb',
      padding: '60px 50px',
      textAlign: 'center',
    },
    ctaTitle: {
      fontSize: '32px',
      fontWeight: '700',
      color: '#1a1a1a',
      margin: '0 0 20px 0',
    },
    ctaText: {
      fontSize: '14px',
      lineHeight: '1.7',
      color: '#4a4a4a',
      margin: '0 0 35px 0',
      maxWidth: '480px',
      marginLeft: 'auto',
      marginRight: 'auto',
    },
    ctaButton: {
      display: 'inline-block',
      padding: '17px 65px',
      backgroundColor: '#1a1a1a',
      color: '#ffffff',
      textDecoration: 'none',
      textTransform: 'uppercase',
      fontWeight: '600',
      fontSize: '12px',
      letterSpacing: '2px',
      borderRadius: '25px',
      cursor: 'pointer',
      border: 'none',
    },
    footer: {
      backgroundColor: '#1a1a1a',
      padding: '50px 40px 35px 40px',
      textAlign: 'center',
    },
    socialIcons: {
      margin: '0 0 30px 0',
    },
    socialIcon: {
      display: 'inline-block',
      width: '44px',
      height: '44px',
      backgroundColor: '#2e2e2e',
      borderRadius: '50%',
      margin: '0 9px',
      lineHeight: '44px',
      color: '#ffffff',
      textAlign: 'center',
      textDecoration: 'none',
      fontSize: '18px',
    },
    footerHeading: {
      fontSize: '11px',
      textTransform: 'uppercase',
      letterSpacing: '2px',
      color: '#8a8a8a',
      margin: '0 0 18px 0',
    },
    footerLinks: {
      margin: '0 0 22px 0',
      fontSize: '13px',
      color: '#b8b8b8',
    },
    footerLink: {
      color: '#b8b8b8',
      textDecoration: 'none',
      fontSize: '13px',
      margin: '0 5px',
      background: 'none',
      border: 'none',
      cursor: 'pointer',
      fontFamily: 'inherit',
    },
    footerAddress: {
      fontSize: '12px',
      color: '#8a8a8a',
      lineHeight: '1.7',
      margin: '18px 0',
    },
    footerLegal: {
      fontSize: '10px',
      color: '#5a5a5a',
      lineHeight: '1.6',
      margin: '25px 0 0 0',
      paddingTop: '25px',
      borderTop: '1px solid #2e2e2e',
    },
  };

  return (
    <div style={styles.body}>
      <div style={styles.emailContainer}>
        {/* View online link */}
        <div style={styles.viewOnline}>
          SEE THIS EMAIL ONLINE
        </div>
        
        {/* Logo */}
        <div style={styles.logoSection}>
          <img 
            src="https://samplesphere.com/cdn/shop/files/Logo.png" 
            alt="SampleSphere" 
            style={styles.logo}
          />
        </div>
        
        {/* Hero Banner (Light Beige) */}
        <div style={styles.heroBanner}>
          <div style={styles.heroTitle}>EXCLUSIVE OFFER.</div>
          <div style={styles.heroSubtitle}>FREE SAMPLE PACK.</div>
          <button 
            style={styles.heroButton}
            onClick={() => alert('This is a preview - download link would work in the actual email!')}
          >
            VIEW DETAILS
          </button>
        </div>
        
        {/* Product Section (Dark) */}
        <div style={styles.productSection}>
          <div style={styles.productImage}>
            <img 
              src="https://soaveyoutubebackup.s3.us-east-1.amazonaws.com/sample+(2).png" 
              alt="Sample Pack" 
              style={styles.productImageImg}
            />
          </div>
          <div style={styles.productDetails}>
            <div style={styles.productLabel}>FREE SAMPLE PACK</div>
            <h2 style={styles.productTitle}>Better sound made for you.</h2>
            <p style={styles.productDescription}>
              This exclusive sample pack offers the best of both worlds - convenience and quality connection. Get access to premium sounds that will elevate your productions.
            </p>
            
            <div style={styles.priceDivider}></div>
            
            <div style={styles.saveBadge}>Save 100%*</div>
            <div style={styles.priceContainer}>
              <span style={styles.originalPrice}>$29.95</span>
              <span style={styles.salePrice}>FREE</span>
            </div>
            
            <div style={styles.priceDividerBottom}></div>
            
            <button 
              style={styles.downloadButton}
              onClick={() => alert('This is a preview - download link would work in the actual email!')}
            >
              DOWNLOAD NOW
            </button>
            
            <div style={styles.expiryNotice}>
              <strong style={{ display: 'block', marginBottom: '6px', color: '#ffffff' }}>Limited Time Access</strong>
              Link expires: {expiryDate.toLocaleString()}
            </div>
          </div>
        </div>
        
        {/* CTA Section (Light Beige) */}
        <div style={styles.ctaSection}>
          <div style={styles.ctaTitle}>This is just the beginning.</div>
          <p style={styles.ctaText}>
            This is just a fraction of our sample collection. Come back for more exciting offers you won't want to miss. Make sure you grab this one before time runs out!
          </p>
          <button 
            style={styles.ctaButton}
            onClick={() => alert('This is a preview - download link would work in the actual email!')}
          >
            DOWNLOAD NOW
          </button>
        </div>
        
        {/* Footer (Dark) */}
        <div style={styles.footer}>
          {/* Social Icons */}
          <div style={styles.socialIcons}>
            <span style={styles.socialIcon}>f</span>
            <span style={styles.socialIcon}>t</span>
            <span style={styles.socialIcon}>📷</span>
            <span style={styles.socialIcon}>▶</span>
          </div>
          
          <div style={styles.footerHeading}>SHOP FOR SAMPLESPHERE</div>
          <div style={styles.footerLinks}>
            <button onClick={() => alert('Browse products')} style={styles.footerLink}>Browse all products</button> • 
            <button onClick={() => alert('Locate store')} style={styles.footerLink}>Locate store</button>
          </div>
          
          <div style={styles.footerAddress}>
            SampleSphere Music Group<br />
            Your Location<br />
            City, State ZIP
          </div>
          
          <div style={styles.footerLinks}>
            <button onClick={() => alert('Contact us')} style={styles.footerLink}>Contact us</button> • 
            <button onClick={() => alert('Visit website')} style={styles.footerLink}>samplesphere.com</button> • 
            <button onClick={() => alert('Privacy policy')} style={styles.footerLink}>Privacy policy</button> • 
            <button onClick={() => alert('Unsubscribe')} style={styles.footerLink}>Unsubscribe</button>
          </div>
          
          <div style={styles.footerLegal}>
            You're receiving this email because you've subscribed to free marketing emails. To remove yourself from our mailing list, please click unsubscribe.<br /><br />
            * Featured offer valid while supplies last. Offer valid until {expiryDate.toLocaleDateString()}. Offer cannot be combined with other offers or applied to previous purchases.<br /><br />
            SampleSphere and the SampleSphere logo are trademarks of SampleSphere Music Group.<br />
            © {new Date().getFullYear()} SampleSphere Music Group. All rights reserved.
          </div>
        </div>
      </div>
    </div>
  );
};

export default PreviewPage;



